enum FeedVisibility {
  JUST_ME = "private",
  MY_FEED = "teams",
  EVERYTHING = ""
}

export default FeedVisibility
